import SplitControl from '@/components/business/SplitControl'
import { MenuItemProps } from '@/resources/types/menu/types'
import { HexaV2NavItem } from '@/components/hexa-v2'

const NavItem = ({ menuItem, onClick, isItemActive }: MenuItemProps) => (
  <HexaV2NavItem
    active={isItemActive}
    key={menuItem.id}
    icon={menuItem.icon}
    label={menuItem.text}
    onHxChangeActiveNavItem={onClick}
  />
)

const SplitControlledMenuItem = ({
  menuItem,
  onClick,
  isItemActive,
}: MenuItemProps) => {
  return (
    <>
      {menuItem.featureFlag && menuItem.splitName ? (
        <SplitControl splitName={menuItem.splitName} treatmentOff={null}>
          <NavItem
            menuItem={menuItem}
            onClick={onClick}
            isItemActive={isItemActive}
          />
        </SplitControl>
      ) : (
        <NavItem
          menuItem={menuItem}
          onClick={onClick}
          isItemActive={isItemActive}
        />
      )}
    </>
  )
}

export default SplitControlledMenuItem
